import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { Injectable, inject } from '@angular/core';
import { Globals } from '../shared/models/globals';

@Injectable()
 export class PermissionsService {

 constructor(
    private userService: UserService,
    private _globals: Globals,
    private router: Router,
  ) { }

  canActivate( roles: Array<string>): boolean {
    if (localStorage.getItem('userToken') != null)
    {
      
      //let roles = route.data["roles"] as Array<string>;
      //console.log(roles);
  
      if (roles) {
        for(let role of roles){
          var match = this.userService.roleMatch(roles);
          if (match){
            this._globals.isLoggedIn=true;              
            return true;
          }
          else {
            this._globals.isLoggedIn=false; 
            this.router.navigate(['/login']);
            return false;
          }
        }
        this.router.navigate(['/login']);
        return false;
        
      }
      else{
        this._globals.isLoggedIn=true;
        return true;    
      }
        
    }
    this.router.navigate(['/']);
    return false;
    
  }

 }
 

export const authGuardGuard: CanActivateFn = (route, state) => {
 
  return inject(PermissionsService).canActivate(route.data["roles"]);

};
/*
export const authGuardGuard: CanActivateFn = (
   next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot) => {
      if (localStorage.getItem('userToken') != null)
      {
        
        let roles = next.data["roles"] as Array<string>;
        //console.log(roles);
        if (roles) {
          for(let role of roles){
            var match = this.userService.roleMatch(roles);
            if (match){
              this._globals.isLoggedIn=true;              
              return true;
            }
            else {
              
              this.router.navigate(['/login']);
              return false;
            }
          }
          return false;
          
        }
        else{
          this._globals.isLoggedIn=true;
          return true;    
        }
          
      }
      //this.router.navigate(['/']);
      return false;
} */
